/**
 * First we will load all of this project's JavaScript dependencies which
 * include Vue and Vue Resource. This gives a great starting point for
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    notifications: []
  },

  mutations: {
    setNotifications: (state, notifications) => {
      state.notifications = [...notifications];
    },

    unshiftNotification: (state, notification) => {
      state.notifications.unshift(notification);
    }
  },

  getters: {
    tasksNotifications: state => {
      return state.notifications.filter(
        notif =>
          notif.type === CONST.notifications.status.taskCreated ||
          notif.type === CONST.notifications.status.commentCreated ||
          notif.type === CONST.notifications.status.taskCanceled ||
          notif.type === CONST.notifications.status.taskClosed ||
          notif.type === CONST.notifications.status.taskStatusChanged
      );
    },

    documentsNotifications: state => {
      return state.notifications.filter(
        notif => notif.type === CONST.notifications.status.listDocsUpdated
      );
    }
  }
});

const app = new Vue({
  el: "#app",
  store,
  components: {
    "set-notification-store": require("./components/notification/setNotificationStore.vue").default,
    "notify-dropdown": require("./components/notification/dropdown.vue").default,
    "notify-task-btn": require("./components/notification/tasksBtn.vue").default,
    "notify-task-row": require("./components/notification/taskRow.vue").default,
    "notify-socket": require("./components/notification/socket.vue").default,
    "notify-read": require("./components/notification/read.vue").default,
    "user-dropdown": require("./components/user/dropdown.vue").default,
    "balance-dropdown": require("./components/balance/dropdown.vue").default,
    "new-filter-datepicker": require("./components/filter/datepicker.vue").default,
    "new-filter-period": require("./components/filter/period.vue").default,
    "task-documents": require("./components/task/documents.vue").default,
    "custom-company": require("./components/user/customCompany/index.vue").default,
    "new-urgency-type-list": require("./components/urgency-type/index.vue").default,
    "new-document-type-list": require("./components/document-type/index.vue").default,
    "employees-create-user": require("./components/employees/create-user.vue").default
  }
});

// Fast select init
$(".js-fast-select-companies").fastselect({
  placeholder: "Выберите компанию",
  noResultsText: "Компании не найдены"
});
$(".js-fasst-select-users").fastselect({
  placeholder: "Выберите клиента",
  noResultsText: "Клиент не найден",
  searchPlaceholder: "Искать"
});
$("#approve_true").on("click", function(e) {
  e.preventDefault();
  $(".js_approve_input").val(true);
  $("#js_approve_form").submit();
});
$("#approve_false").on("click", function(e) {
  e.preventDefault();
  $(".js_approve_input").val(false);
  $("#js_approve_form").submit();
});

window.methods = {};

// Methods
methods.readNotification = function(id) {
  axios.post("/notifications/" + id + "/read").catch(function(error) {
    console.error(error);
  });
};
